import type { ReactNode } from 'react';
import { createLink, useRouterState } from '@tanstack/react-router';
import {
  Header,
  HeaderActions,
  HeaderBrand,
  HeaderLogo,
  HeaderLogout,
  HeaderNav,
  HeaderNavItem,
  HeaderTitle,
  HeaderUser,
} from '@azelis/ui/components/header';
import { PageLayout, PageLayoutContent } from '@azelis/ui/components/pageLayout';

import { useAuth } from '@/auth/auth-provider';
import { paths } from '@/routes/paths';

const HeaderNavLink = createLink(HeaderNavItem);

export default function AppLayout({ children }: { children: ReactNode }) {
  const { displayName, logout } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <PageLayout>
      <Header>
        <HeaderBrand>
          <HeaderLogo />
          <HeaderTitle>Questionnaire Assistant</HeaderTitle>
        </HeaderBrand>
        <HeaderNav aria-label="Main">
          <HeaderNavLink
            to={paths.app}
            active={pathname === paths.app}>
            Questionnaire assistant
          </HeaderNavLink>
          <HeaderNavLink
            to={paths.submit}
            search={{ mode: 'file' }}
            active={pathname.startsWith(paths.submit)}>
            New questionnaire
          </HeaderNavLink>
          <HeaderNavLink
            to={paths.overview}
            active={pathname.startsWith(paths.overview)}>
            Overview
          </HeaderNavLink>
        </HeaderNav>
        <HeaderActions>
          <HeaderUser>{displayName}</HeaderUser>
          <HeaderLogout onClick={logout} />
        </HeaderActions>
      </Header>
      <PageLayoutContent>{children}</PageLayoutContent>
    </PageLayout>
  );
}
